import React, { useEffect, useState, useRef } from 'react';
import MyExpenseList from './MyExpenseList';
import { Link, useLoaderData, useLocation, useParams } from 'react-router-dom';
import Button from '../../components/button/Button';
import { useDispatch, useSelector } from 'react-redux';
import PopupModal from '../../components/modal/PopupModal.jsx';
import Loader from '../../components/modal/Loader.jsx';
import {
  fetchMyExpenseData,
  fetchExpenseCityFilter,
  setExpenseFinalSubmit,
  getFinalSubmitExpense,
  getMyExpensedata,
} from '../../redux/slice/myExpenseSlice';
import ErrorsPopup from '../sfc/ErrorsPopup.jsx';
import excelIcon from '../../../public/assets/images/excelicon.png'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

//image
import leftArrowIcon from '../../../public/assets/images/leftArrowIcon.png';
import { sfcUserDetails } from '../../redux/slice/sfcUserBasicInfo.js';


const expendetHeaderCSS =
  'flex smAndMd:flex-row  smAndMd:items-center flex-col lg:grow lg:items-center justify-between text-secondary-400 text-xs font-medium';


const expenedParagraphSecondCSS =
  'smAndMd:h-[30px] smAndMd:flex lg:h-[45px] smAndMd:w-full smAndMd:text-left smAndMd:justify-end lg:flex justify-center items-center';


const expendedSemiHeaderCSS =
  'smAndMd:h-[30px] smAndMd:flex lg:h-[45px] lg:flex justify-center items-center lg:bg-[#EEEEEE] smAndMd:w-full w-full smAndMd:text-left lg:text-center';

const MyExpense = () => {
  const [selectedFilter, setSelectedFilter] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorPopupForMissingSFCRoutes, setShowErrorPopupForMissingSFCRoutes] = useState(false);
  const [showMissingDates, setShowMissingDates] = useState([]);
  const [errorMessages, setErrorMessage] = useState('');
  const dispatch = useDispatch();
  const monthId = useParams();
  const { state } = useLocation();
  const {
    isLoading,
    apiError,
    errorMessage,
    myExpenseData,
    expenseCityFilter,
  } = useSelector(getMyExpensedata);
  const finalSubmitExpense = useSelector(getFinalSubmitExpense);
  const sfcEmployeeData = useSelector((state) => state?.sfcUserBasicInfo)

  useEffect(() => {

    if(monthId && state?.fromHomePage) {
      dispatch(fetchMyExpenseData({ expenseMonth: state?.month, expenseYear: state?.year }));
      dispatch(fetchExpenseCityFilter());
    } else if(sfcEmployeeData?.data && Object.keys(sfcEmployeeData?.data).length > 0) {
      dispatch(fetchMyExpenseData(sfcEmployeeData?.data));
      dispatch(fetchExpenseCityFilter());
    }
  }, [dispatch,sfcEmployeeData]);

  const handleFilter = (filter) => {
    setSelectedFilter((prevFilter) => (prevFilter === filter ? '' : filter));
  };

  const filteredExpenses = selectedFilter
    ? myExpenseData.filter(
        (item) =>
          item.status === selectedFilter ||
          item.fromCity === selectedFilter ||
          item.toCity === selectedFilter ||
          item?.highlightExpense === selectedFilter ||
          item?.routesModified && true === selectedFilter && !item?.highlightExpense
      )
    : myExpenseData;

  const validateAllDays = (myExpenseData) => {
  if (!myExpenseData || myExpenseData.length === 0) return false;
  const firstDate = myExpenseData[0].activityDateFormat;
  const [year, month] = firstDate.split("-");
  const TotalDays = new Date(Number(year), Number(month), 0).getDate();
  const recordDays = new Set(
    myExpenseData
      .filter(item => item.activityDateFormat.startsWith(`${year}-${month}`))
      .map(item => new Date(item.activityDateFormat).getDate())
  );
  const missingDates = [];
  for (let day = 1; day <= TotalDays; day++) {
    if (!recordDays.has(day)) {
      missingDates.push(`${String(day).padStart(2, "0")}-${month}-${year}`); // DD-MM-YYYY
    }
  }
  setShowMissingDates(missingDates);
  return sfcEmployeeData?.data?.canSubmit || recordDays.size === TotalDays;
};

  const handlerExpenseSubmit = () => {
     if(filteredExpenses && filteredExpenses?.filter((i) => i.routeNotFound)?.length > 0) {
    setErrorMessage("SFC Routes are not defined.");
    setShowErrorPopupForMissingSFCRoutes(true)
    return;
  }

  if (!validateAllDays(filteredExpenses)) {
    setErrorMessage("Some of the records are missing, Please ensure all days are recorded before submission.");
    setShowErrorPopup(true);
    return;
  }
  const expenseId = filteredExpenses?.find(item => item.expenseId)?.expenseId;
  const { employeeId, companyId } = JSON.parse(localStorage.getItem("userData"));
  setModalOpen(true);
   const { isHospitalSurveyEnable } = JSON.parse(
    localStorage.getItem('userData')
  );
  const finalSubmitData = { expenseId, employeeId, companyId, ...(isHospitalSurveyEnable && {metroAllowance: filteredExpenses[0]?.metroAllowance, photoCopy: filteredExpenses[0]?.photoCopy, localConveyance: filteredExpenses[0]?.localConveyance, parkingCharges: filteredExpenses[0]?.parkingCharges}) }
  dispatch(setExpenseFinalSubmit(finalSubmitData));
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const filteredCityStatusName = [
    'Unsubmitted',
    'Submitted',
    ...expenseCityFilter?.map((item) => item.cityName),
  ];

  useEffect(() => {
      dispatch(sfcUserDetails());
  },[finalSubmitExpense])


  const handleExportToExcel = async () => {
const doc = new jsPDF({
  orientation: "landscape",
  unit: "mm",
  format: "a4",
});

const pageWidth = doc.internal.pageSize.getWidth();   // always 297
const pageHeight = doc.internal.pageSize.getHeight(); // always 210

const isLargeReport = myExpenseData.length >= 1;

// Define table layout constants
const mainTableWidth = 18 + 18 + 28 + 12 + 12 + 8 + 16 + 16 + 14 + 18 + 18 + 22 + 30; // = 230mm
const mainXCenter = (pageWidth - mainTableWidth) / 2; // centers table horizontally = 33.5
const tableEndX = mainXCenter + mainTableWidth;

// =============================================
// SECTION: Employee Details Header
// =============================================
if (sfcEmployeeData?.data) {
  const empData = sfcEmployeeData.data;

  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text(`${sfcEmployeeData?.data?.companyName}`, mainXCenter, 10);

  doc.setFontSize(8);
  let yPosition = 16;

  const col1Label = mainXCenter;
  const col1Value = mainXCenter + 30;
  const col2Label = mainXCenter + 117;
  const col2Value = mainXCenter + 147;

  // Row 1: Employee Code | Employee Name
  doc.setFont(undefined, 'bold');
  doc.text("Employee Code:", col1Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.empCode || ''}`, col1Value, yPosition);
  doc.setFont(undefined, 'bold');
  doc.text("Employee Name:", col2Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.firstName || ''}`, col2Value, yPosition);
  yPosition += 5;

  // Row 2: Designation | Month
  doc.setFont(undefined, 'bold');
  doc.text("Designation:", col1Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.designation || ''}`, col1Value, yPosition);
  doc.setFont(undefined, 'bold');
  doc.text("Month:", col2Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(
    `${empData?.expenseMonth
      ? new Date(empData.expenseMonth).toLocaleString('default', { month: 'long' })
      : '-'}`,
    col2Value,
    yPosition
  );
  yPosition += 5;

  // Row 3: Year | Team
  doc.setFont(undefined, 'bold');
  doc.text("Team:", col1Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.teamName || ''}`, col1Value, yPosition);
  doc.text("Year:", col2Label, yPosition);
  doc.setFont(undefined, 'normal');
  doc.text(`${empData?.expenseYear ? empData?.expenseYear : '-'}`, col2Value, yPosition);
  doc.setFont(undefined, 'bold');
}


const totalRow = [
  '', // Date
  '', // Activity
  '', // From-To
  '', // Category
  '', // Dist
  '', // Way
  'Total:',
  Array.isArray(filteredExpenses)
    ? filteredExpenses.reduce((a, c) => a + (c?.fareEntered ?? 0), 0)
    : 0,
  Array.isArray(filteredExpenses)
    ? filteredExpenses.reduce((a, c) => a + (c?.allowancesEntered ?? 0), 0)
    : 0,
  Array.isArray(filteredExpenses)
    ? filteredExpenses.reduce((a, c) => a + (c?.tadaTotal ?? 0), 0)
    : 0,
  Array.isArray(filteredExpenses)
    ? filteredExpenses.reduce((a, c) => a + (c?.otherExpenseTotal ?? 0), 0)
    : 0,
  '',
  ''
];

// =============================================
// SECTION: Main Expense Table
// =============================================
const flaggedRows = [];
autoTable(doc, {
  head: [[
    'Date', 'Activity', 'From-To City', 'Category',
    'Dist(KM)', 'Way', 'Mode', 'Fare',
    'Allowance', 'TADA Exp', 'OtherExp',
    'Mgr Remarks', 'Adm Remarks'
  ]],
  theme: 'grid',
  body: [...myExpenseData.map(item => [
    item?.activityDateFormat?.split("-")?.reverse()?.join("-") || '',
    item?.activityCode || '',
    // `${item?.fromCity || ''}-${item?.toCity || ''}`,
   (item?.allCity || "").split(",").map(c => c.trim()).join("\n"),
    item?.category || '',
    `${item?.distanceEntered || ''}`,
    item?.wayEntered === 'ONE WAY' ? "OW" : "TW",
    item?.modeOfTransport || '',
    item?.fareEntered ?? '',
    item?.allowancesEntered ?? '',
    item?.tadaTotal ?? '',
    item?.otherExpenseTotal ?? '',
    item?.managerRemarks || '',
    item?.adminRemarks || '',
  ]) ,
totalRow],
   didDrawCell: (data) => {
    const lastCol = data.table.columns.length - 1;
    if (data.section !== 'body' || data.column.index !== lastCol) return;

    const item = myExpenseData[data.row.index];
    if (!item?.routeNotFound) return;

    flaggedRows.push({
      page: doc.internal.getCurrentPageInfo().pageNumber,
      y: data.cell.y,
      height: data.cell.height,
    });
  },
  startY: sfcEmployeeData?.data ? 34 : 8,
  tableWidth: mainTableWidth,
  margin: { left: mainXCenter, right: mainXCenter },
  headStyles: {
    fillColor: [160, 77, 149],
    textColor: [0, 0, 0],
    fontStyle: 'bold',
    fontSize: 7,
  },
  styles: {
    cellPadding: isLargeReport ? 0.8 : 1.5,
    fontSize: isLargeReport ? 6 : 7,
    // overflow: "hidden",
    overflow: "linebreak",
    lineWidth: 0.2,
    lineColor: [180, 180, 180],
  },
  tableLineWidth: 0.3,
  tableLineColor: [100, 100, 100],
 bodyStyles: {
  fillColor: [255, 255, 255],
  textColor: [0, 0, 0],
  },
  alternateRowStyles: {
    fillColor: [255, 255, 255],
  },
  columnStyles: {
    0:  { cellWidth: 18 },
    1:  { cellWidth: 18 },
    2:  { cellWidth: 28 },
    3:  { cellWidth: 12 },
    4:  { cellWidth: 12 },
    5:  { cellWidth: 8  },
    6:  { cellWidth: 16 },
    7:  { cellWidth: 16 },
    8:  { cellWidth: 14 },
    9:  { cellWidth: 18 },
    10: { cellWidth: 18 },
    11: { cellWidth: 22 },
    12: { cellWidth: 30 },
  },
});

flaggedRows.forEach(({ page, y, height }) => {
  doc.setPage(page);
  doc.setDrawColor(255, 0, 0);
  doc.setLineWidth(0.5);
  doc.rect(mainXCenter, y, mainTableWidth, height, 'S');
});

// restore defaults
doc.setDrawColor(180, 180, 180);
doc.setLineWidth(0.2);
doc.setPage(doc.getNumberOfPages());

// =============================================
// SECTION: Summary Totals Table
// =============================================
const summaryColWidth = mainTableWidth / 6;

const expenseTotal = Array.isArray(filteredExpenses)
  ? filteredExpenses.reduce((a, c) => a + (c?.tadaTotal ?? 0), 0)
  : 0;

const otherExpenseTotal = Array.isArray(filteredExpenses)
  ? filteredExpenses.reduce((a, c) => a + (c?.otherExpenseTotal ?? 0), 0)
  : 0;

const metroCharges = filteredExpenses?.[0]?.metroAllowance ?? 0;
const courierPhotoCopy = filteredExpenses?.[0]?.photoCopy ?? 0;
const localConveyance = filteredExpenses?.[0]?.localConveyance ?? 0;
const grandTotal = expenseTotal + otherExpenseTotal + metroCharges + courierPhotoCopy + localConveyance;

autoTable(doc, {
  head: [['Expense Total', 'Other Expense', 'Metro Charges', 'Courier/Photo Copy', 'Local Conveyance' , 'Grand Total']],
  body: [[expenseTotal, otherExpenseTotal, metroCharges, courierPhotoCopy, localConveyance, grandTotal]],
  startY: doc.lastAutoTable.finalY + 4,
  tableWidth: mainTableWidth,
  margin: { left: mainXCenter },
  headStyles: {
    fontStyle: 'bold',
    fillColor: [160, 77, 149],
    textColor: [0, 0, 0],
    fontSize: 8,
  },
  styles: {
    cellPadding: 2,
    fontSize: 8,
    halign: 'center',
    valign: 'middle',
    lineWidth: 0.2,
    lineColor: [180, 180, 180],
  },
  tableLineWidth: 0.3,
  tableLineColor: [100, 100, 100],
  bodyStyles: {
    fillColor: [240, 240, 240],
    textColor: [0, 0, 0],
  },
  columnStyles: {
    0: { cellWidth: summaryColWidth },
    1: { cellWidth: summaryColWidth },
    2: { cellWidth: summaryColWidth },
    3: { cellWidth: summaryColWidth },
    4: { cellWidth: summaryColWidth },
    5: { cellWidth: summaryColWidth },
  },
});

// =============================================
// SECTION: Approved By / Authorized Signatory
// =============================================
const approvedByY = doc.lastAutoTable.finalY + 8;
const labelText = `Approved By: ${sfcEmployeeData?.data?.reportingToName}`;
const signText = "(Authorized Signatory)";

doc.setFontSize(8);
doc.setFont(undefined, 'bold');
doc.text(labelText, tableEndX - 60, approvedByY);

const labelWidth = doc.getTextWidth(labelText);
const lineStartX = tableEndX - 60 + labelWidth + 3;
const lineEndX = tableEndX;

doc.setLineWidth(0.1);
doc.line(lineStartX, approvedByY, lineEndX, approvedByY);

doc.setFont(undefined, 'normal');
doc.setFontSize(7);
doc.text(signText, lineStartX, approvedByY + 4);

// =============================================
// SECTION: Generated Date & Time
// =============================================

const now = new Date();

const generatedDateTime = now.toLocaleString('en-IN', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

const footerY = doc.internal.pageSize.getHeight() - 8;

doc.setFontSize(7);
doc.setFont(undefined, 'normal');
doc.setTextColor(100, 100, 100);

doc.text(
  `Generated on: ${generatedDateTime}`,
  mainXCenter,
  footerY
);

// Restore text color
doc.setTextColor(0, 0, 0);



// =============================================
// SAVE
// =============================================
doc.save("expense-report.pdf");

    };


  return (
    <div className="w-full flex flex-col bg-white lg:pt-14 lg:p-2">
      {showErrorPopup && (
        <ErrorsPopup
          show={showErrorPopup}
          message={errorMessages}
          onClose={() => {
            setShowErrorPopup(false)
            setShowMissingDates([]);
          }}
          showDataInTable= {
            () => {
              return (<div className="flex flex-wrap justify-center gap-1 text-sm max-h-[60px] overflow-y-auto">
                {showMissingDates?.map((date) => (
                  <span key={date} className="px-2 py-0.5 bg-gray-100 rounded">
                    {date}
                  </span>
                ))}
                </div>)
            }
          }
        />
      )}
      {showErrorPopupForMissingSFCRoutes && (
        <ErrorsPopup
          show={showErrorPopupForMissingSFCRoutes}
          message={errorMessages}
          onClose={() => {
            setShowErrorPopupForMissingSFCRoutes(false)
            setErrorMessage("")
          }}
        />
      )}
      {isLoading ? (
        <Loader />
      ) : apiError ? (
        <PopupModal message={errorMessage} type="Fail" isOpen={true} />
      ) : (
        <>
          <div className="flex justify-center items-center w-full h-10  relative p-4 lg:p-2 mt-6 mb-2 lg:mt-0 lg:mb-0 lg:flex lg:justify-start lg:items-center">
            <Link to="/home" className="absolute left-4 lg:hidden">
              <img
                src={leftArrowIcon}
                alt="leftIcon"
                height={'10px'}
                width={'10px'}
              />
            </Link>
            <p className="text-baselg font-bold text-center text-primary lg:text-baselg lg:font-semibold">
              My Expense
            </p>
          </div>

          {/* Filter Buttons */}
          <div className="p-3 lg:p-2 flex gap-6 items-center mb-2 lg:pt-0 lg:mb-0 max-w-full">
          <div className="grow overflow-scroll no-scroll">
          <div className="flex justify-between items-center gap-3 w-full">

            <div className="flex items-center gap-3">
              {filteredCityStatusName &&
                filteredCityStatusName.length > 0 &&
                filteredCityStatusName.map((data, index) => (
                  <button
                    key={index}
                    className={`rounded-3xl px-4 py-1 lg:px-2 border border-line-color text-center whitespace-nowrap ${
                      selectedFilter === data
                        ? 'bg-primary text-white border-primary'
                        : 'bg-white'
                    } transition-all duration-200`}
                    onClick={() => handleFilter(data)}
                  >
                    <p className="text-baseMd lg:text-baseMd lg:pl-2 lg:pr-2">
                      {data}
                    </p>
                  </button>
                ))}
            </div>

            <div className="flex items-center gap-3">
              <div className={`flex items-center gap-2 rounded-3xl px-4 py-1 lg:px-4 border border-gray-300 text-center whitespace-nowrap
               ${selectedFilter === 'NO SFC FOUND'
                        ? 'bg-primary text-white border-primary'
                        : 'bg-white'}
                        transition-all duration-200`} onClick={() => {
                handleFilter('NO SFC FOUND')
              }}>
                <div className="w-5 h-5 bg-red-700 rounded-full"></div>
                <p className="text-baseMd cursor-pointer">No SFC Found</p>
              </div>
              <div className={`flex items-center gap-2 rounded-3xl px-4 py-1 lg:px-4 border border-gray-300 text-center whitespace-nowrap
               ${selectedFilter === true && selectedFilter !== 'NO SFC FOUND'
                        ? 'bg-primary text-white border-primary'
                        : 'bg-white'}
                        transition-all duration-200`} onClick={() => {
                handleFilter(true)
              }}>
                <div className="w-5 h-5 bg-yellow-500 rounded-full"></div>
                <p className="text-baseMd cursor-pointer">Modified Routes</p>
              </div>
              <img src={excelIcon} className='cursor-pointer' alt="excelIcon" width={24} height={24} onClick={handleExportToExcel}/>
            </div>

          </div>
        </div>
      </div>

          <div className="divider-y h-[0.5px] w-[97.5%] ml-[1%] bg-line-color lg:mt-2 lg:mb-[0.5px] smAndMd:mb-2"></div>

          {/* Expense List or No Data */}
          {filteredExpenses && filteredExpenses?.length === 0 ? (
            <div className="flex items-center justify-center mt-56">
              <h3
                className="text-center mt-20 font-bold"
                style={{ color: '#A04D95' }}
              >
                No Data Found
              </h3>
            </div>
          ) : (
            <div className="flex-1 overflow-y-auto">
              {Array.isArray(filteredExpenses) &&
                filteredExpenses?.length > 0 &&
                filteredExpenses?.map((item, index) => (
                  <div key={index}>
                    <MyExpenseList id={index} item={item} isMyExpense={true} />
                    <div className="smAndMd:hidden divider-y h-[1px] w-full bg-line-color lg:h-[0px] lg:bg-none"></div>
                  </div>
                ))}

                {/* grid */}
                <div className="lg:flex lg:flex-row lg:border-b-[1px]  lg:border-l-[1px]  lg:border-r-[1px] lg:border-t-[1px] lg:border-line-color rounded-md   lg:cursor-pointer mx-4 mt-4">
          {[
            { label: 'Metro Charge', value:  Array.isArray(filteredExpenses) && filteredExpenses[0]?.metroAllowance },
            { label: 'Courier/Photo Copy', value: Array.isArray(filteredExpenses) && filteredExpenses[0]?.photoCopy },
            { label: 'Local Conveyance', value: Array.isArray(filteredExpenses) && filteredExpenses[0]?.localConveyance }, // if localConveyance is true then only need to show this column if not not needed to add this row itself
            { label: 'Fare', value: Array.isArray(filteredExpenses) && filteredExpenses?.reduce((a,c) => {
              return a + c?.fareEntered
            },0) },
            { label: 'Allowance', value: Array.isArray(filteredExpenses) && filteredExpenses?.reduce((a,c) => {
              return a + c?.allowancesEntered
            },0) },
            { label: 'Tada Exp', value: Array.isArray(filteredExpenses) && filteredExpenses?.reduce((a,c) => {
              return a + c?.tadaTotal
            },0) },
          ].map((item, index) => {
            const isBorderNeeded =
              index < 4 ? 'md:border-r-[1.5px] lg:border-[#B3B3B3]' : '';
            return (
              <div key={index} className={expendetHeaderCSS}>
                <div className={expendedSemiHeaderCSS}>
                  <p
                    className={`smAndMd:grow smAndMd:border-r-2 smAndMd:border-white lg:grow ${isBorderNeeded} font-medium text-[#514D4C]`}
                  >
                    {item.label}
                  </p>
                </div>
                <div className={expenedParagraphSecondCSS}>₹{item.value}</div>
              </div>
            );
          })}
        </div>


        {/* <div className='flex justify-evenly items-center bg-[#F7F0FF] rounded-md mx-4 mt-4 p-4'>
          <div className='flex gap-4 items-center'>
            <div className='text-[#514D4C] font-medium'>Expense Total</div>
            <div>
              <span>₹</span>
              {filteredExpenses?.reduce((a,c) => {
              return a + c?.tadaTotal
            },0)}
            </div>
          </div>
          <div className='flex gap-4 items-center'>
            <div className='text-[#514D4C] font-medium'>Other Expense</div>
            <div>
              <span>₹</span>
              {filteredExpenses?.reduce((a,c) => {
              return a + c?.otherExpenseTotal
            },0)}
            </div>
          </div>
          <div className='flex gap-4 items-center'>
            <div className='text-[#514D4C] font-medium'>Grand Total</div>
            <div>
              <span>₹</span>
              {filteredExpenses?.reduce((a, c) => a + (c?.tadaTotal ?? 0) + (c?.otherExpenseTotal ?? 0), 0)}
            </div>
          </div>
        </div> */}



        <div className='flex flex-col sm:flex-row justify-evenly items-start sm:items-center bg-[#F7F0FF] rounded-md mx-4 mt-4 p-4 gap-3 sm:gap-0 divide-y divide-[#E0D9F0] sm:divide-y-0'>
  <div className='flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0 first:pt-0'>
    <div className='text-[#514D4C] font-medium'>Expense Total</div>
    <div>
      <span>₹</span>
      {Array.isArray(filteredExpenses) && filteredExpenses?.reduce((a, c) => a + (c?.tadaTotal ?? 0), 0)}
    </div>
  </div>
  <div className='flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0'>
    <div className='text-[#514D4C] font-medium'>Other Expense</div>
    <div>
      <span>₹</span>
      {Array.isArray(filteredExpenses) && filteredExpenses?.reduce((a, c) => a + (c?.otherExpenseTotal ?? 0), 0)}
    </div>
  </div>
  <div className='flex gap-4 items-center w-full sm:w-auto pt-3 sm:pt-0'>
    <div className='text-[#514D4C] font-medium'>Grand Total</div>
    <div>
      <span>₹</span>
      {Array.isArray(filteredExpenses)
      &&
      filteredExpenses?.reduce((a, c) =>
      a + (c?.tadaTotal ?? 0) +
      (c?.otherExpenseTotal ?? 0), 0) +
      (filteredExpenses?.[0]?.metroAllowance ?? 0) +
      (filteredExpenses?.[0]?.photoCopy ?? 0) +
      (filteredExpenses?.[0]?.localConveyance ?? 0)
      }
    </div>
  </div>
</div>

              <div className="divider-y h-[0.5px] w-[98%] ml-[1%] mt-4 mb-2 bg-line-color"></div>
              {monthId && state?.fromHomePage ? null : <div className="smAndMd:hidden lg:flex w-full items-center gap-3 p-3 justify-around lg:justify-end">
              <Button
                  label="Submit"
                  btBgColor="bg-primary"
                  btTextColor="text-white"
                  btHeight = 'h-10'
                  btWidth = 'w-36'
                  onClick={handlerExpenseSubmit}
                />
              </div>}

              <div className="mb-28 lg:mb-0"></div>
            </div>
          )}

          {/* Submit Button */}
          {monthId && state?.fromHomePage ? null : Array.isArray(filteredExpenses) &&
                filteredExpenses?.length > 0 &&(
            <div className="lg:hidden fixed bottom-0 bg-white border-t-[1px] shadow-top1 h-[7rem]  w-full flex justify-around items-center gap-3 p-4">
              <Button
                btFullwidth={true}
                label="Submit"
                btBgColor="bg-primary"
                btTextColor="text-white"
                onClick={handlerExpenseSubmit}
              />
            </div>
          )}
          {/* PopupModal */}
          {finalSubmitExpense && (
            <PopupModal
              time={1000}
              isOpen={modalOpen}
              message={finalSubmitExpense?.message}
              type={finalSubmitExpense?.status}
              onClose={closeModal}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MyExpense;
